export default __webpack_public_path__ + "static/fondoModalLogin-44d7fe20103ce001c1ef59f4b01d0400.png";